import dynamic from "next/dynamic";

export const DynamicLayoutWidget086 = dynamic(
  () => import("./LayoutWidget086"),
  {
    suspense: true,
  }
);
